import AzureBackend from './implementation';
import API from './API';
import AuthenticationPage from './AuthenticationPage';

export const DecapCmsBackendAzure = {
  AzureBackend,
  API,
  AuthenticationPage,
};
export { AzureBackend, API, AuthenticationPage };
